import Parseable from '@/misc/Parseable';
import Phone from '@/interfaces/phone.interface';

export default class Promoter extends Parseable {
    public id!: string;
    public firstName!: string;
    public lastName!: string;
    public mail!: string;
    public phone!: Phone;
    public passengerCount!: number;
    public rideCount!: number;
    public companyName?: string;
    /**
     * How many completed rides one of this promoter's referred drivers has to
     * finish before the promoter starts earning commission on them. The
     * threshold ride itself does not earn -- the next one is the first.
     */
    public activationThreshold: number = 10;

    public static parseFromObject(object: Partial<Promoter>): Promoter {
        const promoter = new Promoter();
        Object.assign(promoter, object);
        return promoter;
    }

    public get name() {
        return `${this.firstName} ${this.lastName}`;
    }

    public parseToObject(): Partial<Promoter> {
        const tmp = { ...this };
        return tmp;
    }
}
